// FRONTEND API ROUTES
export const FE_AUTH_VALIDATE_API = '/api/auth/validate'
export const FE_AUTH_LOGOUT_API = '/api/auth/logout'
export const FE_AUTH_FORCE_LOGOUT_API = '/api/auth/forceLogout/new/session'
export const FE_AUTH_TOUCH_API = '/api/auth/touch'
export const FE_COOKIE_API = '/api/cookie'
export const FE_LOG_CLIENT_ERROR_API = '/api/log-client-error'

// AUTH API
export const LOGOUT_API = 'auth/web/logout'
export const FORCE_LOGOUT_AND_CREATE_NEW_SESSION_API =
  'web/enc/auth/forceLogout/new/session'
export const LOGIN_API = 'web/enc/auth/login'
export const VALIDATE_OTP_API = 'web/enc/auth/validate'

// CITY API
export const GET_ALL_CITY_LIST_API = 'web/enc/city/all'
export const GET_RADIOLOGY_AND_GENERAL_CITY_LIST_API = 'web/enc/city'
export const GET_CITY_DETAILS_BY_PINCODE_API = 'web/enc/city/by/pincode'
export const GEO_POSITION_SERVICABLE_API = 'web/enc/polygon/serviceable'
export const LOCATION_NOT_SERVICEABLE = 'web/enc/city/not/serviceable'
export const GET_ALL_STATE_LIST_API = 'web/enc/state/all'
export const GET_CITY_BY_STATE_ID_API = 'web/enc/city/by/state'

// MAP API
export const GMAP_BASE_URL = 'https://maps.googleapis.com/maps/'
export const MAP_GEOCODE = 'web/google/api/geocode'
export const MAP_AUTOCOMPLETE = 'web/google/api/place/autocomplete'
export const MAP_PLACE_DETAILS = 'web/google/api/place/details'

// PATIENT API
export const PATIENT_SEARCH_API = 'web/enc/patient/search'
export const CREATE_PATIENT_API = 'web/enc/patient/create'
export const DELETE_PATIENT_API = 'web/enc/patient/delete'
export const UPDATE_PATIENT_API = 'web/enc/patient/update'
export const PATIENT_SEARCH_ALL_API = 'web/enc/patient/search/all'
export const PATIENT_FAMILY_UPDATE = 'web/enc/patient/family/update'
export const SEND_OTP = 'web/enc/otp/send'
export const VALIDATE_OTP = 'web/enc/otp/validate'
export const CREATE_FAMILY_MEMBER = 'web/enc/patient/family/member/add'

export const GET_PATIENT_ADDRESS_API = 'web/enc/patient/address/fetchAll'
export const ADD_PATIENT_ADDRESS_API = 'web/enc/patient/address/add'
export const EDIT_PATIENT_ADDRESS_API = 'web/enc/patient/address/update/'
export const DELETE_PATIENT_ADDRESS_API = 'web/enc/patient/address/delete/'

// HOME API
export const SIGNED_IN_HOME_DETAILS_API = 'web/enc/home/details/v2'
export const SIGNED_OUT_HOME_DETAILS_API = 'internal/web/enc/home/details/v2'
export const CARE_PACKAGE_CATEGORY_API = 'web/enc/product/category/carePackage'
export const CARE_PACKAGE_CATEGORY_PRODUCT_API =
  'web/enc/product/category/carePackage/product'

// PRODUCT API
export const SIGNED_OUT_PRODUCT_SEARCH_API = 'web/enc/product/search/x-api/v2'
export const SIGNED_IN_PRODUCT_SEARCH_API = 'web/enc/product/search/v2'
export const PRODUCT_CHECK_DUPLICATES_API = 'web/enc/product/checkDuplicate/all'
export const GET_PRODUCT_CONSTITUENTS_API = 'web/product/constituents'
export const GET_PDP_API = 'web/product/data/pdp'
export const LOG_ZERO_PRICE_API = 'web/enc/product/price-zero/log'

// CART API
export const CART_LIST_API = 'web/enc/cart/list'
export const ADD_PRODUCT_IN_CART_API = 'web/enc/cart/add'
export const DELETE_CART_API = 'web/enc/cart/delete'
export const REMOVE_DUPLICATE_PRODUCT_API = 'web/enc/cart/remove/product'
export const CART_RESTORE_API = 'web/enc/cart/restore'

//ORDER API
export const FETCH_COUPON_API = 'web/enc/order/coupon'
export const CREATE_PATIENT_ORDER_API = 'web/enc/order/add'
export const GET_ORDER_LISTING = 'web/enc/order/listing'
export const GET_ORDER_DETAIL_API = 'web/enc/order/detail'
export const CANCEL_ORDER = 'web/enc/order/cancel'

export const GET_CANCELLATION_REASONS = 'web/enc/reason'

// LOYALTY API
export const GET_LOYALTY_POINTS_API = 'web/enc/loyalty/availablePoints'
export const CHECK_POINTS_REDEMPTION_API =
  'web/enc/loyalty/checkPointsRedemption'
export const LOYALTY_LEDGER_API = 'web/enc/loyalty/ledger'

// SLOT API
export const GET_AVAILABLE_SLOT_API = 'web/enc/slot/available/v2'

//Payment API
export const GET_PAYMENT_ACCESS_KEY = 'web/enc/payment/webLink/initiate'
export const GET_ORDER_PAYMENT_STATUS = 'web/enc/payment/detail'

// DOCUMENT API
export const SIGNED_IN_DOCUMENT_LEAD_API = 'web/enc/document/lead'
export const SIGNED_OUT_DOCUMENT_LEAD_API = 'web/enc/document/lead'
export const PATIENT_DOCUMENT_UPLOAD_API = 'web/document/upload/v2'

// OTHERS API
export const WEBSITE_SECTION_ADD_API = 'website/section/add'

export const GET_ALL_REPORTS = 'web/enc/report'
export const GET_SMART_REPORT = 'web/enc/healthTracker/viewSmartReport'
export const GET_ELEMENT_DETAIL = 'web/enc/healthTracker/elementDetail'
export const DOWNLOAD_REPORT = 'web/enc/report/download'
export const DOWNLOAD_SMART_REPORT = 'web/enc/report/download/smart'

// EDOS API
export const GET_EDOS_PRODUCT_LIST_API = 'product/edos/city/product-list'

// CAMPAIGN API
export const GET_CAMPAIGN_PRODUCT_LIST_API = 'web/campaign/data'
export const GET_CAMPAIGN_DATA_API = 'web/campaign/data/v2'
export const POST_CAMPAIGN_LEAD_API = 'web/enc/document/lead/campaign'

// SITEMAP API
export const GET_SITEMAP_PRODUCT_ALL = 'web/product/all'

// NEARBY LABS
export const GET_LAB_FILTER = 'web/client/location/filters'
export const GET_LAB_LISTING = 'web/client/location/listing'
export const GET_LAB_DETAILS = 'web/client/location/detail'

//CAREERS page
export const SUBMIT_JOB_APPLICATION = 'career/jobApplication'
export const FETCH_DEPARTMENT_DESIGNATION_API = 'career/department/positions'

//PRODUCT CATEGORY
export const PRODUCT_CATEGORY_API = 'web/product/category/disease'
export const PRODUCT_CATEGORY_VIEW_ALL_API =
  'web/product/category/disease/product'
export const PRODUCT_CATEGORY_NON_CITY_API =
  'web/enc/product/category/disease/product/non-city'

//Most popular health check up api
export const POPULAR_HEALTH_CHECKUPS_API =
  'web/product/category/popular/product'

export const POPULAR_PRODUCT_PRICES_API = 'web/product/popular-product-prices'

export const POPULAR_CITY_PRICES_API = 'web/product/popular-city-prices'

export const PRODUCT_CITY_ALL_API = 'web/product/product-city-all'

export const FETCH_SAVINGS = 'web/enc/order/savings'

//BANNER APIs
export const GET_BANNER_API = 'pulse/banner/list/byConfig'

//PEOPLE APIs
export const GET_PEOPLE_API = 'pulse/people/public/byConfig'

//DOCUMENT APIs
export const GET_DOCUMENTS_API = 'pulse/document/public/byConfig'
//POLICY PAGE APIs
export const GET_POLICY_PAGE_API = 'pulse/policy-page/public/detail'
//TESTIMONIAL APIs
export const GET_TESTIMONIALS_API = 'web/enc/cms/public/testimonials'

//GMB APIs
export const GMB_REVIEW_API = 'web/gmb/review'
